/* Shared helpers for the /embed/* standalone journeys (host-app webviews).

   Result delivery channels (all attempted):
   1. window.parent / window.opener postMessage (target locked via ?host_origin=)
   2. React Native WebView:   window.ReactNativeWebView.postMessage(json)
   3. Android JS interface:   window.OneHealthBridge.onFaceScanResult(json)
   4. Flutter JS channel:     window.OneHealthChannel.postMessage(json)
   5. iOS WKWebView handler:  webkit.messageHandlers.oneHealthFaceScan.postMessage(json)
   6. redirect_url (if given): redirected to with ?result=<base64url(JSON)> */

export const b64url = (s) =>
  btoa(unescape(encodeURIComponent(s))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

/* Common embed query params: employee_id, lang, redirect_url (scheme-filtered),
   host_origin. */
export function commonEmbedParams(q) {
  const get = (k) => (q.get(k) || "").trim();
  let redirectUrl = get("redirect_url");
  if (redirectUrl && !/^(https?|[a-z][a-z0-9+.-]*):\/\//i.test(redirectUrl)) redirectUrl = "";
  if (/^(javascript|data|vbscript|file|blob):/i.test(redirectUrl)) redirectUrl = "";
  return {
    employeeId: get("employee_id").slice(0, 64) || "MANUAL",
    lang: get("lang"),
    redirectUrl,
    hostOrigin: get("host_origin"),
  };
}

/* Push the result to every host-app channel that exists. */
export function deliverToHost(message, redirectUrl, hostOrigin) {
  const json = JSON.stringify(message);
  const target = hostOrigin || "*"; // pass ?host_origin= to lock postMessage to one origin
  let delivered = false;
  try { if (window.parent && window.parent !== window) { window.parent.postMessage(message, target); delivered = true; } } catch (_) {}
  try { if (window.opener) { window.opener.postMessage(message, target); delivered = true; } } catch (_) {}
  try { if (window.ReactNativeWebView?.postMessage) { window.ReactNativeWebView.postMessage(json); delivered = true; } } catch (_) {}
  try { if (window.OneHealthBridge?.onFaceScanResult) { window.OneHealthBridge.onFaceScanResult(json); delivered = true; } } catch (_) {}
  try { if (window.OneHealthChannel?.postMessage) { window.OneHealthChannel.postMessage(json); delivered = true; } } catch (_) {}
  try {
    const h = window.webkit?.messageHandlers?.oneHealthFaceScan;
    if (h?.postMessage) { h.postMessage(json); delivered = true; }
  } catch (_) {}
  if (redirectUrl) {
    try {
      const u = new URL(redirectUrl);
      u.searchParams.set("result", b64url(json));
      window.location.replace(u.toString());
      delivered = true;
    } catch (e) { console.warn("invalid redirect_url", e?.message); }
  }
  return delivered;
}
